import { Box, Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { Link } from '~/components/atoms/Link';
import { HOME_PATH } from '~/constants';

export const NotFound: FC = () => {
  return (
    <Stack py={4} gap={2}>
      <Typography variant="h1" textAlign="center">
        404 Not Found
      </Typography>

      <Typography textAlign="center">
        {"We couldn't find the page you're looking for. Try checking the URL or heading back to the home page."}
      </Typography>

      <Box display="flex" justifyContent="center">
        <Link to={HOME_PATH}>Back to Home</Link>
      </Box>
    </Stack>
  );
};
